import React from 'react';
import { Users, Trash2 } from 'lucide-react';

const ROLE_BADGE = {
  admin: 'bg-purple-100 text-purple-700 border-purple-200',
  advisor: 'bg-blue-100 text-primaryDark border-blue-200',
  'investment banker': 'bg-amber-100 text-amber-700 border-amber-200',
};

const RoleBadge = ({ role }) => (
  <span className={`px-2 py-0.5 rounded-full text-xs border capitalize ${ROLE_BADGE[role] ?? 'bg-gray-100 text-gray-600 border-gray-200'}`}>
    {role ?? '—'}
  </span>
);

const AdvisorsTable = ({ groupName, advisors, loading, deleteAdivsorFromGroup, groupId }) => {
  return (
    <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
      <h4 className="text-sm font-medium text-gray-700 mb-3">Advisors for {groupName}</h4>

      {loading ? (
        <div className="flex justify-center py-4">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-custom-blue"></div>
        </div>
      ) : advisors && advisors.length > 0 ? (
        <div className="overflow-x-auto">
        <table className="w-full min-w-[700px]">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Username
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Role
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {advisors.map(advisor => (
              <tr key={advisor.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                      <Users className="w-5 h-5 text-custom-blue" />
                    </div>
                    <div className="ml-4">
                      <div className="text-sm font-medium text-gray-900">{advisor.username}</div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm font-medium text-gray-900">{advisor.users}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <RoleBadge role={advisor.role} />
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <div className="flex gap-2">
                    <button
                      onClick={() => {
                        if (window.confirm(`Remove ${advisor.username} from ${groupName}?`)) {
                          deleteAdivsorFromGroup(groupId, advisor.id);
                        }
                      }}
                      className="text-red-600 hover:text-red-900 p-1 rounded"
                      title="Remove from group"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      ) : (
        <div className="text-center py-6">
          <p className="text-sm text-gray-500 italic">No advisors assigned to this group.</p>
        </div>
      )}
    </div>
  );
};

export default AdvisorsTable;
